import React from "react";
import Header from "./Header";
import useNowPlayingMovies from "../hooks/useNowPlayingMovies";
import MainContainer from "./MainContainer";
import SecondaryContainer from "./SecondaryContainer";
import usePopularMovies from "../hooks/usePopularMovies";
import useTopRatedMovies from "../hooks/useTopRatedMovies";
import useUpcomingMovies from "../hooks/useUpcomingMovies";
import GeminiSearchPage from "./GeminiSearchPage";
import { useSelector } from "react-redux";
import WatchList from "./WatchList";

const Browse = () => {
  const showGptSearch = useSelector((store) => store.gpt.showGptSearch);
  const watchList = useSelector((store) => store.movies.watchList);

  useNowPlayingMovies();
  usePopularMovies();
  useTopRatedMovies();
  useUpcomingMovies();

  return (
    <div>
      <Header />
      {showGptSearch ? (
        <GeminiSearchPage />
      ) : watchList ? (
        <WatchList />
      ) : (
        <>
          <MainContainer />
          <SecondaryContainer />
        </>
      )}
    </div>
  );
};

export default Browse;
